/* eslint-disable max-len */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import HubspotForm from 'react-hubspot-form'
import { Modal } from 'react-responsive-modal'
import Layout from '../../components/layout'
import close from '../../assets/detailed-close.svg'
import ContactForm from '../../components/contactform'
import CallToAction from '../../components/calltoaction'
import { ATELIER_PAGE_CONTENTFUL_ID } from '../../utils/vars'
import ContentfulClient from '../../contentful'

import MetaHeaders from '../../components/metaheaders'
import bannerImg from '../../assets/atelier-background.png'
import purpleHair from '../../assets/purple-hair-brown-hair.png'
import heroText from '../../assets/ucl-header-atelier-text.png'
import monaLisaImg from '../../assets/mona-lisa.png'
import jaguarImg from '../../assets/jaguar.png'
import greenClothes from '../../assets/bags.png'
import monaLisaSwag from '../../assets/clothing-items.png'
import styles from './Atelier.module.scss'

const Atelier = ({
    metaTitle,
    metaDescription,
    marqueeText,
    description1,
    description2,
    description3,
    text1,
    galleryText1,
    galleryText2,
    visionText1,
    visionText2,
}) => {
    const [showContactForm, setShowContactForm] = useState(false)

    const onCloseModal = () => {
        setShowContactForm(false)
    }

    return (
        <>
            <MetaHeaders
                title={metaTitle}
                description={metaDescription}
            />
            <Layout>
                <div className={styles.atelier}>
                    <div className={styles.banner} style={{ backgroundImage: `url(${bannerImg})`, backgroundRepeat: 'no-repeat' }}>
                        <div className={styles.wrapper}>
                            <div className={styles.atelierLogo}>
                                <img src={heroText} className={styles.heroText} alt="Urban Coolab Atelier logo" />
                            </div>
                        </div>
                    </div>
                    <div className={styles.sentenceInfo}>
                        <div className={styles.sentence}>
                            <span>an artifical intelligence design lab and collab platform for:</span>

                            <div className={styles.marqueeWrapper}>
                                <div className={styles.marquee}>
                                    <p>
                                        ‎
                                        {' '}
                                        {marqueeText}
                                    </p>
                                    <p>
                                        ‎
                                        {' '}
                                        {marqueeText}
                                    </p>
                                </div>
                            </div>
                            <div className={styles.mobileHeader}>
                                <p> PHYSICAL FASHION </p>
                                <p> DIGITAL FASHION </p>
                                <p> ART </p>
                                <p> NFTs </p>
                            </div>
                            <ContactForm
                                name="Contact Atelier"
                                contactFormStyles={{
                                    textTransform: 'uppercase',
                                    fontFamily: '$font, $fallback-font, $fallback-font2, $fallback-font3, $fallback-font4',
                                    color: 'white',
                                    border: 'none',
                                }}
                                showContactForm={() => setShowContactForm(true)}
                            />
                            {showContactForm && (
                                <Modal
                                    open={showContactForm}
                                    onClose={() => onCloseModal()}
                                    classNames={{
                                        overlay: 'hubSpotOverlay',
                                        modal: 'hubSpotModal',
                                    }}
                                >
                                    <HubspotForm
                                        portalId="7162797"
                                        formId="475a24d2-c091-443b-b596-a65efc032896"
                                    />
                                    <button
                                        type="button"
                                        className="closeBtn"
                                        onClick={() => setShowContactForm(false)}
                                    >
                                        <img alt="Close contact form" src={close} />
                                        <div className="sr-only">Close contact form</div>
                                    </button>
                                </Modal>
                            )}
                        </div>
                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.fontWrapper}>
                            <span><strong>What is Atelier UCL?</strong></span>
                            <p>
                                {description1}
                            </p>
                            <p>
                                {description2}
                            </p>
                        </div>
                    </div>
                    <div className={styles.secondBanner}>
                        <img src={purpleHair} alt="Two 3d avatars looking into eachothers eyes" />
                        {' '}
                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.fontWrapper}>
                            <span><strong>The future of A.I.</strong></span>
                            <p className={styles.marginBottom}>
                                {description3}
                            </p>
                        </div>
                        <div className={styles.fontWrapper}>
                            <span><strong>What we do</strong></span>
                            <p>
                                {text1}

                            </p>
                            <p>
                                <strong>01/</strong>
                                {' '}
                                our artificial intelligence machine creates
                                {' '}
                                <span className={styles.textUnderline}>
                                    original designs
                                </span>
                                {' '}
                                using classical and/or contemporary inspirations as its focal point.
                            </p>
                            <p>
                                <strong>02/</strong>
                                {' '}
                                our artificial intelligence machine can
                                {' '}
                                <span className={styles.textUnderline}>
                                    collaborate with multiple creators
                                </span>
                                {' '}
                                on commissioned projects in the physical form or virtually in the Metaverse.
                            </p>
                            <div className={styles.fontWrapperContact}>
                                <CallToAction showContactForm={() => setShowContactForm(true)} />
                                {showContactForm && (
                                    <Modal
                                        open={showContactForm}
                                        onClose={() => onCloseModal()}
                                        classNames={{
                                            overlay: 'hubSpotOverlay',
                                            modal: 'hubSpotModal',
                                        }}
                                    >
                                        <HubspotForm
                                            portalId="7162797"
                                            formId="475a24d2-c091-443b-b596-a65efc032896"
                                        />
                                        <button
                                            type="button"
                                            className="closeBtn"
                                            onClick={() => setShowContactForm(false)}
                                        >
                                            <img alt="Close contact form" src={close} />
                                            <div className="sr-only">Close contact form</div>
                                        </button>
                                    </Modal>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={styles.wrapper}>
                        <div className={styles.galleryHeader}>
                            <span>
                                <h3>
                                    <strong>
                                        Lab output no. 18
                                    </strong>
                                </h3>
                                <h4>
                                    Lemonardo x Mona Lisa
                                </h4>
                            </span>
                        </div>

                        <div className={styles.galleryDiv}>
                            <div className={styles.galleryImg}>
                                <img src={monaLisaImg} alt="Mona Lisa potrait with blank face" />
                            </div>
                            <div className={styles.galleryText}>
                                <p>
                                    {galleryText1}
                                </p>
                                <div>
                                    <img src={monaLisaSwag} alt="pieces of clothing with altered mona lisa on them" />
                                </div>
                            </div>
                        </div>

                        <div className={styles.galleryHeader}>
                            <span>
                                <h3>
                                    <strong>
                                        Lab output no. 39
                                    </strong>
                                </h3>
                                <h4>
                                    Balenciaga x Gucci
                                </h4>
                            </span>
                        </div>
                        <div className={styles.galleryDiv2}>
                            <div className={styles.galleryImg}>
                                <img src={jaguarImg} alt="AI created gold jaguar" />
                            </div>
                            <div className={styles.galleryText2}>
                                <p>
                                    {galleryText2}
                                </p>
                                <div>
                                    <img src={greenClothes} alt="Green bags and jacket" />
                                </div>
                            </div>
                        </div>

                        <div className={styles.fontWrapper}>
                            <span><strong>Our Vision</strong></span>
                            <p>
                                {visionText1}
                            </p>
                            <p className={styles.marginBottom}>
                                {visionText2}
                            </p>
                            <ContactForm
                                name="Contact Atelier"
                                contactFormStyles={{
                                    textTransform: 'uppercase',
                                    fontFamily: '$font, $fallback-font, $fallback-font2, $fallback-font3, $fallback-font4',
                                    color: 'white',
                                    border: 'none',
                                }}
                                showContactForm={() => setShowContactForm(true)}
                            />
                            {showContactForm && (
                                <Modal
                                    open={showContactForm}
                                    onClose={() => onCloseModal()}
                                    classNames={{
                                        overlay: 'hubSpotOverlay',
                                        modal: 'hubSpotModal',
                                    }}
                                >
                                    <HubspotForm
                                        portalId="7162797"
                                        formId="475a24d2-c091-443b-b596-a65efc032896"
                                    />
                                    <button
                                        type="button"
                                        className="closeBtn"
                                        onClick={() => setShowContactForm(false)}
                                    >
                                        <img alt="Close contact form" src={close} />
                                        <div className="sr-only">Close contact form</div>
                                    </button>
                                </Modal>
                            )}
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

Atelier.propTypes = {
    metaTitle: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
    marqueeText: PropTypes.string.isRequired,
    description1: PropTypes.string.isRequired,
    description2: PropTypes.string.isRequired,
    description3: PropTypes.string.isRequired,
    text1: PropTypes.string.isRequired,
    galleryText1: PropTypes.string.isRequired,
    galleryText2: PropTypes.string.isRequired,
    visionText1: PropTypes.string.isRequired,
    visionText2: PropTypes.string.isRequired,
}

Atelier.getInitialProps = async () => {
    const res = await ContentfulClient.getEntry(ATELIER_PAGE_CONTENTFUL_ID)
    return res.fields
}

export default Atelier
